import { addDays, endOfDay, startOfDay } from 'date-fns'
import React from 'react'
import {
  DateRangePicker,
  createStaticRanges,
  defaultStaticRanges,
} from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { ActionButton } from '../JobPreview/style'
import { CustomDateRangeContainer, PositionBox } from './PageHeader/style'
const customStaticRanges = createStaticRanges([
  {
    label: 'Tomorrow',
    range: () => ({
      startDate: startOfDay(addDays(new Date(), 1)),
      endDate: endOfDay(addDays(new Date(), 1)),
    }),
  },
])

const combinedStaticRanges = [...defaultStaticRanges, ...customStaticRanges]
const insertionIndex = 2
combinedStaticRanges.splice(insertionIndex, 0, customStaticRanges[0])

const CustomDateRange = ({
  handleCustomDateClick,
  isCustomRange,
  state,
  setState,
}) => {
  return (
    <CustomDateRangeContainer>
      <div className={isCustomRange ? 'customCalendarWrap' : 'calendarWrap'}>
        <div>
          <DateRangePicker
            onChange={item => setState([item.selection])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            showMonthArrow
            direction="horizontal"
            staticRanges={combinedStaticRanges}
          />
          <PositionBox>
            <ActionButton
              text={'Custom Range'}
              staticColor={'#E5E7EB'}
              fontColor={'#1F2937'}
              fontSize={'10px'}
              onClick={handleCustomDateClick}
              rangeColors={'#F4F4F4'}
              color={{
                start: {
                  backgroundColor: '#F4F4F4',
                },
                end: {
                  backgroundColor: 'red',
                },
              }}
              customHeight={'26px'}
              style={{ padding: '0px 10px' }}
            />
          </PositionBox>
        </div>
      </div>
    </CustomDateRangeContainer>
  )
}

export default CustomDateRange
